import React from 'react'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import posthog from 'posthog-js'
import { cashinForMng } from 'services/loans'

export default function useSetCashinMng() {
    const navigate = useNavigate()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IFuckingPayload) => {
            return cashinForMng(payload)
        },
        onSuccess: (data, variables) => {
            posthog.capture('payment_recorded', { flow_type: 'manager_record', amount: (variables as any)?.amount })
            toast.success('واریز با موفقیت ثبت شد')
            navigate('/funds')
        },
        onError: () => {
            posthog.capture('payment_record_failed', { flow_type: 'manager_record' })
            toast.error('خطایی رخ داده')
        },
    })

    return { isLoading, mutate }
}
